import { useSyncExternalStore } from "react";

type Listener = () => void;

let isOpen = false;
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const openUploadPhysicianFormModal = () => {
  if (isOpen) return;
  isOpen = true;
  notify();
};

export const closeUploadPhysicianFormModal = () => {
  if (!isOpen) return;
  isOpen = false;
  notify();
};

const subscribe = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => isOpen;

export const useUploadPhysicianFormModalOpen = () =>
  useSyncExternalStore(subscribe, getSnapshot);
